import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./TopInjector.module.scss";

/**
 * An injector ad that runs just below the nav with styling
 * on load. This has poor viewability but is important for sales.
 */
const TopInjectorAd = ({ className, ...props }: GptAdProps) => {
  return (
    <GptAd
      className={cx(styles.root, className)}
      format="injector"
      sizesAt0="mobile-wide"
      sizesAt976="desktop-wide"
      targetingPos={props.targetingPos || "topboxpremium"}
      {...props}
    />
  );
};

export default TopInjectorAd;
